import React, {useEffect, useRef, useState} from "react"
import PropTypes from "prop-types"
import {useTranslation} from "react-i18next"
import {Alert, Button, Card, CardBody, CardTitle, Col, Container, Form, FormGroup, Label, Row} from "reactstrap"
import {connect} from "react-redux"
import { useLocation, withRouter } from "react-router-dom"

//Date Picker
import {registerLocale, setDefaultLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"
import 'react-phone-number-input/style.css'

import ptBR from "date-fns/locale/pt-BR"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import {
    buscarGrupoCardapio,
    buscarGruposCardapioItemPorGrupo,
    buscarGruposCardapioObservacaoPorGrupo,
    cadastrarGrupoCardapio,
    cadastrarGrupoCardapioMantemCadastro,
    cadastrarGrupoCardapioObservacao,
    editarGrupoCardapio,
    editarGrupoCardapioObservacao,
    removerGrupoCardapio,
    removerGrupoCardapioObservacao
} from "../../store/auth/profile/actions"
import usePermission from "helpers/permission/usePermission"
import StickerToolbarButtons from "../../components/Common/sticker-toolbar-buttons"
import AlertaSemVinculo from "../../components/Common/alerta-sem-vinculo"
import toastr from "toastr"
import swal from "sweetalert"
import {
    apiBuscarConfiguracoesImpressoraPesquisa,
    apiBuscarProximoCodigoGrupoCardapio,
    apiTraduzirGrupoCardapio
} from "../../helpers/backend_helper"
import {paraCorFastfood, paraCorWeb} from "../../helpers/color_helper"
import Loader from "react-loader-spinner"
import FormInputSwitch from "../../components/Common/form-input-switch"
import FormInputNumber from "../../components/Common/form-input-number"
import FormInputText from "../../components/Common/form-input-text"
import FormInputAsyncSelect from "../../components/Common/form-input-async-select"
import "toastr/build/toastr.min.css"
import FormSelectCompany from "../../components/Common/form-select-company"
import FormInputDate from "../../components/Common/form-input-date"
import moment from "moment-timezone"
import FormInputColor from "../../components/Common/form-input-color"
import FormInputFile from "../../components/Common/form-input-file"
import GrupoCardapioObservacaoLista from "./grupo-cardapio-observacao-lista"
import GrupoCardapioItemLista from "./grupo-cardapio-item-lista"
import {getCompanies, getCompanyOption} from "../../helpers/utils"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import ButtonRedirect from "../../components/Common/button-redirect"

const brazilMoment = (...args) => moment(...args)
registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

const IDIOMA_EN_US = 'EN_US'
const IDIOMA_ES = 'ES'

const CadastrarCardapioDigitalGrupo = props => {

    const { t } = useTranslation()
    const [paramIdCloud, setParamIdCloud] = useState(undefined)
    const usePermissionGruposCardapioObservacaoList = usePermission("gruposCardapioObservacao_listar")
    const usePermissionGruposCardapioItemList = usePermission("gruposCardapioItem_listar")
    const usePermissionEdit = usePermission("gruposCardapio_editar")
    const usePermissionInsert = usePermission("gruposCardapio_inserir")
    const usePermissionRemove = usePermission("gruposCardapio_excluir")
    const possuiVinculo = (props.user?.vinculos || []).some(vinculo => ["A", "T"].includes(vinculo.vinculo_status))

    // Registros com iCodigo preenchido foram originados em outro contexto (Fastfood local) e não
    // podem ser editados pelo InfoCloud — o bloqueio vale para cliente e usuário interno da Inforangra.
    const bloqueadoPorICodigo = !!props.grupoCardapio?.iCodigo

    const [companies, setCompanies] = useState([{label: "Todas", value: ""}])
    const [clonado, setClonado] = useState(false)
    const [loading, setLoading] = useState(false)

    const [id, setId] = useState()
    const [empresa, setEmpresa] = useState()
    const [codigo, setCodigo] = useState()
    const [iCodigo, setICodigo] = useState(0)
    const [descricao, setDescricao] = useState()
    const [dataAlteracao, setDataAlteracao] = useState() // Alteração do cadastro - AltData
    const [usuarioAlteracao, setUsuarioAlteracao] = useState() // Usuário que alterou - AltFunc
    const [impressora, setImpressora] = useState()
    const [textoTela, setTextoTela] = useState()
    const [corBotao, setCorBotao] = useState()
    const [corFonte, setCorFonte] = useState()
    const [subGrupo, setSubGrupo] = useState('N')
    const [desktopVisivel, setDesktopVisivel] = useState('N')
    const [mobileVisivel, setMobileVisivel] = useState('N')
    const [infinitiFoodVisivel, setInfinitiFoodVisivel] = useState('N')
    const [menuDigitalVisivel, setMenuDigitalVisivel] = useState('N')
    const [imagem, setImagem] = useState()
    const [ordem, setOrdem] = useState()
    const [monitorKds, setMonitorKds] = useState()
    const [descricaoEnUs, setDescricaoEnUs] = useState()
    const [descricaoEs, setDescricaoEs] = useState()
    const [descricaoOriginal, setDescricaoOriginal] = useState() // Descrição em português como veio do banco
    const [traduzindo, setTraduzindo] = useState(false)
    const [sincronizar, setSincronizar] = useState()
    const location = useLocation()

    const getAndSearch = (idCloud)=>{
        props.buscarGrupoCardapio({id: idCloud}, props.history)
        props.navegarBreadCrumb( {title: `breadcrumb.digital.menu`, link: location.pathname, id: idCloud})
    }

    // Sugere COALESCE(MAX(Codigo),0)+1 da empresa ao abrir uma nova categoria. É conveniência:
    // o campo continua editável e uma falha aqui não impede o preenchimento manual.
    //
    // manterDigitado: não sobrescreve um código que o usuário já informou (ex.: a lista de empresas
    // recarregou). Ao trocar de empresa a sugestão é refeita, pois o código anterior era de outra empresa.
    // Só a resposta da última consulta é aplicada, para uma troca rápida de empresa não trazer o código errado.
    const consultaCodigoAtual = useRef(0)
    const sugerirProximoCodigo = async (empresaId, { manterDigitado = false } = {}) => {
        if (!empresaId) return
        const consulta = ++consultaCodigoAtual.current
        try {
            const { proximoCodigo } = await apiBuscarProximoCodigoGrupoCardapio({ idEmpresa: empresaId })
            if (consulta !== consultaCodigoAtual.current) return
            setCodigo(codigoAtual => (manterDigitado && codigoAtual) ? codigoAtual : proximoCodigo)
        } catch (error) {
            toastr.warning(t("grupocardapio.cadastro.codigo.sugestao.erro"))
        }
    }

    const selecionarEmpresa = empresaId => {
        setEmpresa(empresaId)
        if (!id) sugerirProximoCodigo(empresaId)
    }

    useEffect(() => {
        if(paramIdCloud !== undefined) return

        const idCloud = props.match.params.hasOwnProperty('idCloud') ? props.match.params.idCloud : null
        if (idCloud) {
            getAndSearch(idCloud)
        } else {
            preencherFormulario(null)

            setId(null)
            setEmpresa(companies[0].value)
            props.navegarBreadCrumb( {title: `breadcrumb.digital.menu.new`, link: location.pathname })
        }

        setClonado(false)
        setParamIdCloud(idCloud)

    }, [props.match.params])

    useEffect(() => {
        if (props.permanecerCadastro === true) {
            setLoading(true)
            // A nova categoria continua na empresa da que acabou de ser gravada.
            const empresaDoCadastro = empresa || companies[0]?.value

            setTimeout(() => {
                preencherFormulario(null)

                setId(null)
                setEmpresa(empresaDoCadastro)
                sugerirProximoCodigo(empresaDoCadastro)

                setClonado(false)
                setLoading(false)
            }, 1000)
        }
    }, [props.permanecerCadastro])

    useEffect(() => {
        if (props.grupoCardapio && props.grupoCardapio?.id) {
            preencherFormulario(props.grupoCardapio)

            props.buscarGruposCardapioObservacaoPorGrupo({
                company: props.grupoCardapio?.idEmpresa, codigoGrupoCardapio: props.grupoCardapio?.Codigo
            })

            props.buscarGruposCardapioItemPorGrupo({
                company: props.grupoCardapio?.idEmpresa, codigoGrupoCardapio: props.grupoCardapio?.Codigo
            })

        }
    }, [props.grupoCardapio])

    useEffect(() => {
        if (props.grupoCardapio?.Codigo &&
            ((props.novoGrupoCardapioObservacao && props.novoGrupoCardapioObservacao.id) ||
                (props.grupoCardapioObservacaoRemovido) ||
                (props.grupoCardapioObservacaoEditado))) {
            props.buscarGruposCardapioObservacaoPorGrupo({
                company: props.grupoCardapio?.idEmpresa, codigoGrupoCardapio: props.grupoCardapio?.Codigo
            })
        }
    }, [props.novoGrupoCardapioObservacao, props.grupoCardapioObservacaoEditado, props.grupoCardapioObservacaoRemovido])

    const preencherFormulario = (grupoCardapio) => {
        // Só 'N' esconde a categoria: vazio e nulo valem "Sim", como no grid. Novo cadastro nasce visível.
        const visivel = valor => valor === 'N' ? 'N' : 'S'

        setId(grupoCardapio?.id)
        setEmpresa(grupoCardapio?.idEmpresa)
        setCodigo(grupoCardapio?.Codigo)
        setICodigo(grupoCardapio?.iCodigo)
        setDescricao(grupoCardapio?.Descricao)
        setDescricaoOriginal(grupoCardapio?.Descricao)
        setDescricaoEnUs(grupoCardapio?.Descricao_EN_US)
        setDescricaoEs(grupoCardapio?.Descricao_ES)
        setImpressora(grupoCardapio?.Impressora ? buildConfiguracaoImpressora(grupoCardapio?.Impressora.idId, grupoCardapio?.Impressora.serie) : undefined)
        setTextoTela(grupoCardapio?.Texto_Tela)
        // As cores são gravadas no formato do Fastfood e editadas no formato web. O valor original é
        // guardado para ser regravado como está quando o usuário não mexer na cor.
        coresOriginais.current = {
            botao: { bruto: grupoCardapio?.Cor_Botao ?? null, web: paraCorWeb(grupoCardapio?.Cor_Botao) },
            fonte: { bruto: grupoCardapio?.Cor_Fonte ?? null, web: paraCorWeb(grupoCardapio?.Cor_Fonte) }
        }
        setCorBotao(coresOriginais.current.botao.web)
        setCorFonte(coresOriginais.current.fonte.web)
        setSubGrupo(grupoCardapio?.SubGrupo ? grupoCardapio?.SubGrupo : 'N')
        setDesktopVisivel(visivel(grupoCardapio?.Desktop_Visivel))
        setMobileVisivel(visivel(grupoCardapio?.Mobile_Visivel))
        setInfinitiFoodVisivel(visivel(grupoCardapio?.Infinitifood_Visivel))
        setMenuDigitalVisivel(visivel(grupoCardapio?.MenuDigital_Visivel))
        setImagem(grupoCardapio?.Imagem)
        setOrdem(grupoCardapio?.Ordem)
        setMonitorKds(grupoCardapio?.monitor_kds)
        setSincronizar(grupoCardapio?.sincronizar)

        setDataAlteracao(grupoCardapio?.AltData ? brazilMoment(grupoCardapio?.AltData, "YYYY-MM-DD HH:mm:ss").toDate() : null)
        setUsuarioAlteracao(`${grupoCardapio?.AltFunc} - ${grupoCardapio?.AltFunc_Nome || "N/A"}`)
    }

    // Cor que o usuário não alterou volta ao banco como estava (inclusive formatos sem conversão).
    const coresOriginais = useRef({ botao: null, fonte: null })
    const corParaGravar = (corWeb, original) =>
        (original && corWeb === original.web) ? original.bruto : paraCorFastfood(corWeb)

    const possuiTraducao = !!(descricaoEnUs || descricaoEs)
    const descricaoAlterada = !!descricaoOriginal && descricao !== descricaoOriginal
    const atualizandoTraducao = possuiTraducao && descricaoAlterada

    const aplicarTraducoes = (traducoes) => {
        if (traducoes?.[IDIOMA_EN_US]) setDescricaoEnUs(traducoes[IDIOMA_EN_US])
        if (traducoes?.[IDIOMA_ES]) setDescricaoEs(traducoes[IDIOMA_ES])
    }

    // Preenche apenas os idiomas vazios. Sobrescrever tradução existente sempre passa por confirmação,
    // e uma falha da IA nunca impede o preenchimento manual ou a gravação da categoria.
    const gerarTraducoes = async () => {
        if (!descricao) {
            toastr.warning(t("grupocardapio.cadastro.traducao.semdescricao"))
            return
        }

        const idiomasVazios = []
        if (!descricaoEnUs) idiomasVazios.push(IDIOMA_EN_US)
        if (!descricaoEs) idiomasVazios.push(IDIOMA_ES)

        const sobrescrever = idiomasVazios.length === 0 || atualizandoTraducao
        const idiomas = sobrescrever ? [IDIOMA_EN_US, IDIOMA_ES] : idiomasVazios

        if (sobrescrever) {
            const confirmado = await swal({
                title: t("grupocardapio.cadastro.traducao.confirmar.titulo"),
                text: t("grupocardapio.cadastro.traducao.confirmar.texto"),
                icon: "warning",
                buttons: [
                    t("grupocardapio.cadastro.traducao.confirmar.cancelar"),
                    t("grupocardapio.cadastro.traducao.confirmar.ok")
                ]
            })
            if (!confirmado) return
        }

        setTraduzindo(true)
        try {
            const traducoes = await apiTraduzirGrupoCardapio({ idEmpresa: empresa, descricao, idiomas })
            aplicarTraducoes(traducoes)
            // A partir daqui, mudar a descrição em português oferece "Atualizar traduções" (também no cadastro novo).
            setDescricaoOriginal(descricao)
            toastr.success(t("grupocardapio.cadastro.traducao.sucesso"))
        } catch (error) {
            toastr.warning(error?.response?.data?.message || t("grupocardapio.cadastro.traducao.erro"))
        } finally {
            setTraduzindo(false)
        }
    }

    const excluirGrupoCardapio = () => {
        props.removerGrupoCardapio({id}, props.history)
    }

    const clonarGrupoCardapio = () => {
        // O clone nasce na mesma empresa da categoria de origem.
        const empresaDoCadastro = empresa || companies[0]?.value
        setId(null)
        setCodigo(null)
        setEmpresa(empresaDoCadastro)
        sugerirProximoCodigo(empresaDoCadastro)
        props.grupoCardapio.id = null
        props.grupoCardapio.Codigo = null
        props.grupoCardapio.iCodigo = null // caso seja clonado não deverá haver o iCodigo

        window.scrollTo(0, 0)
    }

    const gravarGrupoCardapio = (e, cadastrarOutroGrupoCardapio) => {
        let valid = true
        valid = valid && (!!empresa)
        valid = valid && (!!descricao)
        valid = valid && (!!codigo)

        if (!valid) {
            const divs = document.getElementsByName("validate-required")
            for (let i = 0; i < divs.length; i++) {
                divs[i].style.display = "block"
            }
            window.scrollTo(0, 0)
            toastr.error('Há campos obrigatórios não preenchidos!', 'Validação de informações')

            return
        }

        salvarGrupoCardapio(cadastrarOutroGrupoCardapio)
    }

    const salvarGrupoCardapio = (cadastrarOutroGrupoCardapio) => {
        const grupoCardapio = props.grupoCardapio ? Object.assign({}, props.grupoCardapio) : {}

        grupoCardapio.idEmpresa = empresa
        grupoCardapio.Codigo = codigo
        grupoCardapio.iCodigo = iCodigo
        grupoCardapio.Descricao = descricao
        grupoCardapio.Descricao_EN_US = descricaoEnUs || null
        grupoCardapio.Descricao_ES = descricaoEs || null
        grupoCardapio.Impressora = impressora ? impressora.value : null
        grupoCardapio.Texto_Tela = textoTela
        grupoCardapio.Cor_Botao = corParaGravar(corBotao, coresOriginais.current.botao)
        grupoCardapio.Cor_Fonte = corParaGravar(corFonte, coresOriginais.current.fonte)
        grupoCardapio.SubGrupo = subGrupo
        grupoCardapio.Desktop_Visivel = desktopVisivel
        grupoCardapio.Mobile_Visivel = mobileVisivel
        grupoCardapio.Infinitifood_Visivel = infinitiFoodVisivel
        grupoCardapio.MenuDigital_Visivel = menuDigitalVisivel
        grupoCardapio.Imagem = imagem
        grupoCardapio.Ordem = (ordem === '' || ordem === null || ordem === undefined) ? 0 : ordem
        grupoCardapio.monitor_kds = monitorKds ?? null

        if (grupoCardapio.id) {
            props.editarGrupoCardapio(grupoCardapio, props.history)
        } else {
            if (cadastrarOutroGrupoCardapio) {
                props.cadastrarGrupoCardapioMantemCadastro(grupoCardapio, props.history)
            } else {
                props.cadastrarGrupoCardapio(grupoCardapio, props.history)
            }
        }
    }

    const buildConfiguracaoImpressora = (idId, serie) => {
        return {label: `${idId} - ${serie}`, value: idId}
    }

    const buscarConfiguracaoImpressora = (inputValue, callback) => {
        return apiBuscarConfiguracoesImpressoraPesquisa({empresaId: empresa, argumento: inputValue})
            .then(results => {
                const options = results.map(({idId, serie}) => {
                    return buildConfiguracaoImpressora(idId, serie)
                })

                callback(options)
            })
    }

    useEffect(() => {
        const tmpCompanies = Array.isArray(props.empresas)
            ? props.empresas.map(empresa => getCompanyOption(empresa))
            : getCompanies(props.user)
        setCompanies(tmpCompanies)

        if (!props.grupoCardapio?.id) {
            const preSelectedEmpresa = location.state?.empresaPreSelecionada
            const empresaAlvo = preSelectedEmpresa || (tmpCompanies.length > 0 ? tmpCompanies[0].value : undefined)
            if (preSelectedEmpresa) {
                setEmpresa(preSelectedEmpresa)
            } else if (tmpCompanies.length > 0) {
                setEmpresa(tmpCompanies[0].value)
            }
            sugerirProximoCodigo(empresaAlvo, { manterDigitado: true })
        }

        return () => {
            setCompanies([])
        }
    }, [props.user, props.empresas])

    const cadastrarGrupoCardapioObservacao = (itemSelecionado) => {
        let grupoCardapioObservacao = { ...itemSelecionado }
        grupoCardapioObservacao.idEmpresa = empresa
        grupoCardapioObservacao.Codigo_Grupo = codigo
        props.cadastrarGrupoCardapioObservacao(grupoCardapioObservacao, props.history)
    }

    const removerGrupoCardapioObservacao = (itemSelecionado) => {
        props.removerGrupoCardapioObservacao({id: itemSelecionado.id}, props.history)
    }

    const editarGrupoCardapioObservacao = (itemSelecionado) => {
        props.editarGrupoCardapioObservacao(itemSelecionado, props.history)
    }

    if (!props.user || !possuiVinculo) {
        return (<AlertaSemVinculo/>)
    }

    return <React.Fragment>
        {props.grupoCardapioLoading || loading ? (<div className="loader-container position-absolute">
            <Loader
                type="ThreeDots"
                color="#556EE6"
                height={80}
                width={80}
            />
        </div>) : (<div className="page-content">
            <Container fluid>
                <Breadcrumbs
                    title={ id ? "breadcrumb.group.categories.edit" : "breadcrumb.group.categories.new" }
                />
                <StickerToolbarButtons>
                    <ButtonRedirect path={"grupos-cardapio"} history={props.history}></ButtonRedirect>
                    {id && <>
                        <Button
                            type="submit"
                            color="primary"
                            className="waves-effect waves-light me-2"
                            disabled={!empresa || !(id && usePermissionEdit) || props.grupoCardapio?.iCodigo}
                            onClick={e => gravarGrupoCardapio(e)}>
                            {clonado ? "Cadastrar categoria" : "Salvar categoria"}
                        </Button>
                        <Button
                            type="submit"
                            color="primary"
                            className="waves-effect waves-light me-2"
                            disabled={!usePermissionInsert}
                            onClick={e => clonarGrupoCardapio(e)}>
                            {"Clonar categoria"}
                        </Button>
                        <Button
                            type="submit"
                            color="danger"
                            className="waves-effect waves-light me-2"
                            disabled={!(usePermissionRemove) || props.grupoCardapio?.iCodigo}
                            onClick={e => excluirGrupoCardapio(e)}>
                            {"Remover categoria"}
                        </Button>
                    </>
                    }

                    {!id && !clonado &&
                        <>
                            <Button
                                type="submit"
                                color="primary"
                                className="waves-effect waves-light me-2"
                                disabled={!empresa || !usePermissionInsert}
                                onClick={e => gravarGrupoCardapio(e)}>
                                {"Cadastrar categoria"}
                            </Button>

                            <Button
                                type="submit"
                                color="secondary"
                                className="waves-effect waves-light me-2 btn-secondary"
                                disabled={!empresa || !usePermissionInsert}
                                onClick={e => gravarGrupoCardapio(e, true)}>
                                {"Cadastrar e Preencher nova categoria"}
                            </Button>
                        </>
                    }

                    {clonado && <Button
                        type="submit"
                        color="primary"
                        className="waves-effect waves-light me-2"
                        disabled={!empresa || !usePermissionInsert}
                        onClick={e => gravarGrupoCardapio(e)}>
                        {"Cadastrar categoria"}
                    </Button>}
                </StickerToolbarButtons>
                { bloqueadoPorICodigo &&
                    <Alert color="warning" className="d-flex align-items-center">
                        <i className="mdi mdi-lock-outline font-size-18 me-2"/>
                        {t("grupocardapio.cadastro.bloqueado")}
                    </Alert>
                }
                <Row>
                    <Col lg="12">
                        <div>
                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-4">{t("grupocardapio.cadastro.secao.identificacao")}</CardTitle>
                                    <Form>
                                        <div className="outer">
                                            <div className="outer">
                                                {id && <FormGroup className="mb-4" row>
                                                    <Label htmlFor="empresa"
                                                           className="col-form-label col-lg-2">
                                                        {t("grupocardapio.cadastro.campo.identificador")}
                                                    </Label>
                                                    <Col lg="10" className="col-form-label">
                                                        {id}
                                                    </Col>
                                                </FormGroup>}

                                                {id && <FormGroup className="mb-4" row>
                                                    <Label htmlFor="codigo" className="col-form-label col-lg-2">
                                                        {t("grupocardapio.cadastro.campo.codigo")}
                                                    </Label>
                                                    <Col lg="10" className="col-form-label">
                                                        {codigo}
                                                    </Col>
                                                </FormGroup>}

                                                {!id && <FormInputNumber
                                                    attribute="codigo"
                                                    description={t("grupocardapio.cadastro.campo.codigo")}
                                                    placeholder={t("grupocardapio.cadastro.campo.codigo.placeholder")}
                                                    value={codigo}
                                                    setValue={setCodigo}
                                                    allowNegative={false}
                                                    max={9999999}
                                                    required={true}
                                                />}

                                                <FormSelectCompany
                                                    attribute="empresa"
                                                    placeholder={t("grupocardapio.cadastro.campo.empresa.placeholder")}
                                                    value={empresa}
                                                    setValue={selecionarEmpresa}
                                                    options={companies.filter(c => c.value)}
                                                    required={true}
                                                    disabled={(props.grupoCardapio?.id !== null && props.grupoCardapio?.id !== undefined) || false}
                                                />

                                                <FormInputText
                                                    attribute="descricao"
                                                    description={t("grupocardapio.cadastro.campo.descricao")}
                                                    placeholder={t("grupocardapio.cadastro.campo.descricao.placeholder")}
                                                    value={descricao}
                                                    setValue={setDescricao}
                                                    required={true}
                                                    maxLength={45}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputText
                                                    attribute="textoTela"
                                                    description={t("grupocardapio.cadastro.campo.textotela")}
                                                    placeholder={t("grupocardapio.cadastro.campo.textotela.placeholder")}
                                                    value={textoTela}
                                                    setValue={setTextoTela}
                                                    required={true}
                                                    maxLength={30}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputAsyncSelect
                                                    dependencyKey={empresa}
                                                    attribute="impressora"
                                                    description={t("grupocardapio.cadastro.campo.impressora")}
                                                    value={impressora}
                                                    setValue={setImpressora}
                                                    loadOptions={buscarConfiguracaoImpressora}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                            </div>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>

                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-4">{t("grupocardapio.cadastro.secao.exibicao")}</CardTitle>
                                    <Form>
                                        <div className="outer">
                                            <div className="outer">

                                                <FormInputNumber
                                                    attribute="ordem"
                                                    description={t("grupocardapio.cadastro.campo.ordem")}
                                                    placeholder={t("grupocardapio.cadastro.campo.ordem.placeholder")}
                                                    value={ordem}
                                                    setValue={setOrdem}
                                                    allowNegative={false}
                                                    decimalScale={0}
                                                    max={999999}
                                                    min={0}
                                                    additionalText={t("grupocardapio.cadastro.campo.ordem.ajuda")}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputSwitch
                                                    attribute="subGrupo"
                                                    description={t("grupocardapio.cadastro.campo.subgrupo")}
                                                    value={subGrupo}
                                                    setValue={setSubGrupo}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputSwitch
                                                    attribute="desktopVisivel"
                                                    description={t("grupocardapio.cadastro.campo.desktopvisivel")}
                                                    value={desktopVisivel}
                                                    setValue={setDesktopVisivel}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputSwitch
                                                    attribute="mobileVisivel"
                                                    description={t("grupocardapio.cadastro.campo.mobilevisivel")}
                                                    value={mobileVisivel}
                                                    setValue={setMobileVisivel}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputSwitch
                                                    attribute="infinitiFoodVisivel"
                                                    description={t("grupocardapio.cadastro.campo.infinitifoodvisivel")}
                                                    value={infinitiFoodVisivel}
                                                    setValue={setInfinitiFoodVisivel}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputSwitch
                                                    attribute="menuDigitalVisivel"
                                                    description={t("grupocardapio.cadastro.campo.menudigitalvisivel")}
                                                    value={menuDigitalVisivel}
                                                    setValue={setMenuDigitalVisivel}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputNumber
                                                    attribute="monitorKds"
                                                    description={t("grupocardapio.cadastro.campo.monitorkds")}
                                                    placeholder={t("grupocardapio.cadastro.campo.monitorkds.placeholder")}
                                                    value={monitorKds}
                                                    setValue={setMonitorKds}
                                                    allowNegative={false}
                                                    decimalScale={0}
                                                    max={999}
                                                    min={0}
                                                    additionalText={t("grupocardapio.cadastro.campo.monitorkds.ajuda")}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputColor
                                                    attribute="corBotao"
                                                    keyTranslate="grupocardapio.cadastro.campo.corbotao"
                                                    value={corBotao || "#000000"}
                                                    setValue={setCorBotao}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputColor
                                                    attribute="corFonte"
                                                    keyTranslate="grupocardapio.cadastro.campo.corfonte"
                                                    value={corFonte || "#FFFFFF"}
                                                    setValue={setCorFonte}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormGroup className="mb-4" row>
                                                    <Label className="col-form-label col-lg-2">
                                                        {t("grupocardapio.cadastro.campo.previa")}
                                                    </Label>
                                                    <Col lg="10" className="col-form-label">
                                                        <Button
                                                            type="button"
                                                            style={ { backgroundColor: corBotao || "#000000", color: corFonte || "#FFFFFF" } }
                                                            className="waves-effect waves-light me-2">
                                                            {descricao || t("grupocardapio.cadastro.campo.previa.exemplo")}
                                                        </Button>
                                                    </Col>
                                                </FormGroup>

                                                <FormInputFile
                                                    attribute="imagem"
                                                    description={t("grupocardapio.cadastro.campo.imagem")}
                                                    extension={"image/png, image/jpeg"}
                                                    value={imagem}
                                                    setValue={setImagem}
                                                    loading={ false }
                                                    disabled={bloqueadoPorICodigo}
                                                    removeHandeler={ () => setImagem({ remover: true }) }/>

                                            </div>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>

                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-4">{t("grupocardapio.cadastro.secao.traducoes")}</CardTitle>
                                    <Form>
                                        <div className="outer">
                                            <div className="outer">

                                                <FormInputText
                                                    attribute="descricaoEnUs"
                                                    description={t("grupocardapio.cadastro.campo.descricaoenus")}
                                                    placeholder={t("grupocardapio.cadastro.campo.descricaoenus.placeholder")}
                                                    value={descricaoEnUs}
                                                    setValue={setDescricaoEnUs}
                                                    maxLength={90}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormInputText
                                                    attribute="descricaoEs"
                                                    description={t("grupocardapio.cadastro.campo.descricaoes")}
                                                    placeholder={t("grupocardapio.cadastro.campo.descricaoes.placeholder")}
                                                    value={descricaoEs}
                                                    setValue={setDescricaoEs}
                                                    maxLength={90}
                                                    disabled={bloqueadoPorICodigo}
                                                />

                                                <FormGroup className="mb-0" row>
                                                    <Col lg={{ size: 10, offset: 2 }}>
                                                        <Button
                                                            type="button"
                                                            color="secondary"
                                                            className="waves-effect waves-light me-2"
                                                            disabled={!descricao || bloqueadoPorICodigo || traduzindo}
                                                            onClick={ () => gerarTraducoes() }>
                                                            <i className="mdi mdi-translate me-1"/>
                                                            { traduzindo
                                                                ? t("grupocardapio.cadastro.traducao.gerando")
                                                                : atualizandoTraducao
                                                                    ? t("grupocardapio.cadastro.traducao.atualizar")
                                                                    : t("grupocardapio.cadastro.traducao.gerar") }
                                                        </Button>
                                                        <span className="text-muted">
                                                            {t("grupocardapio.cadastro.traducao.ajuda")}
                                                        </span>
                                                    </Col>
                                                </FormGroup>

                                            </div>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>

                            { id && usePermissionGruposCardapioItemList && <Card>
                                <CardBody>
                                    <CardTitle className="mb-4">Itens da categoria</CardTitle>
                                    <GrupoCardapioItemLista
                                        listaGrupoCardapioItem={props.gruposCardapioItem}
                                        loading={props.gruposCardapioItemLoading}
                                    >
                                    </GrupoCardapioItemLista>
                                </CardBody>
                            </Card> }

                            { id && usePermissionGruposCardapioObservacaoList && <Card>
                                <CardBody>
                                    <CardTitle className="mb-4">Observações da categoria</CardTitle>
                                    <GrupoCardapioObservacaoLista
                                        listaGrupoCardapioObservacao={props.gruposCardapioObservacao}
                                        cadastrarGrupoCardapioObservacao={cadastrarGrupoCardapioObservacao}
                                        removerGrupoCardapioObservacao={removerGrupoCardapioObservacao}
                                        editarGrupoCardapioObservacao={editarGrupoCardapioObservacao}
                                        loading={props.grupoCardapioObservacaoLoading || props.gruposCardapioObservacaoLoading}
                                        disabled={ props.grupoCardapio?.iCodigo }
                                    >
                                    </GrupoCardapioObservacaoLista>
                                </CardBody>
                            </Card> }

                            { id && <Card>
                                <CardBody>
                                    <CardTitle className="mb-4">{t("grupocardapio.cadastro.secao.auditoria")}</CardTitle>
                                    <Form>
                                        <div className="outer">
                                            <div className="outer">

                                                <FormInputDate
                                                    attribute="dataAlteracao"
                                                    description={t("grupocardapio.cadastro.campo.altdata")}
                                                    value={dataAlteracao}
                                                    disabled={true}
                                                    dateFormat={'dd/MM/yyyy HH:mm:ss'}
                                                    withHour={true}
                                                />

                                                <FormInputText
                                                    attribute="usuarioAlteracao"
                                                    description={t("grupocardapio.cadastro.campo.altfunc")}
                                                    value={usuarioAlteracao}
                                                    disabled={true}
                                                />

                                                <FormInputText
                                                    attribute="sincronizar"
                                                    description={t("grupocardapio.cadastro.campo.sincronizar")}
                                                    value={sincronizar === 'S'
                                                        ? t("grupocardapio.cadastro.campo.sincronizar.pendente")
                                                        : t("grupocardapio.cadastro.campo.sincronizar.sincronizado")}
                                                    disabled={true}
                                                />

                                            </div>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card> }
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>)}
    </React.Fragment>
}

CadastrarCardapioDigitalGrupo.propTypes = {
    grupoCardapioAtivo: PropTypes.any,
    grupoCardapio: PropTypes.any,
    grupoCardapioLoading: PropTypes.bool,
    permanecerCadastro: PropTypes.any,
    grupoCardapioObservacao: PropTypes.any,
    grupoCardapioObservacaoLoading: PropTypes.bool,
    gruposCardapioObservacao: PropTypes.any,
    gruposCardapioObservacaoLoading: PropTypes.bool,
    gruposCardapioItem: PropTypes.any,
    gruposCardapioItemLoading: PropTypes.bool,
    novoGrupoCardapioObservacao: PropTypes.any,
    grupoCardapioObservacaoRemovido: PropTypes.any,

    buscarGrupoCardapio: PropTypes.func,
    cadastrarGrupoCardapio: PropTypes.func,
    cadastrarGrupoCardapioMantemCadastro: PropTypes.func,
    editarGrupoCardapio: PropTypes.func,
    removerGrupoCardapio: PropTypes.func,
    buscarGruposCardapioObservacaoPorGrupo: PropTypes.func,
    cadastrarGrupoCardapioObservacao: PropTypes.func,
    removerGrupoCardapioObservacao: PropTypes.func,
    editarGrupoCardapioObservacao: PropTypes.func,
}

const mapStatetoProps = state => {
    const {
        grupoCardapioAtivo,
        grupoCardapio,
        grupoCardapioLoading,
        permanecerCadastro,
        grupoCardapioObservacao,
        grupoCardapioObservacaoLoading,
        gruposCardapioItem,
        gruposCardapioItemLoading,
        gruposCardapioObservacao,
        gruposCardapioObservacaoLoading,
        novoGrupoCardapioObservacao,
        grupoCardapioObservacaoRemovido,
        grupoCardapioObservacaoEditado,
        empresas
    } = state.Profile
    const {user} = state.Login
    return {
        user,
        empresas,
        grupoCardapioAtivo,
        grupoCardapio,
        grupoCardapioLoading,
        permanecerCadastro,
        grupoCardapioObservacao,
        grupoCardapioObservacaoLoading,
        gruposCardapioObservacao,
        gruposCardapioObservacaoLoading,
        gruposCardapioItem,
        gruposCardapioItemLoading,
        novoGrupoCardapioObservacao,
        grupoCardapioObservacaoRemovido,
        grupoCardapioObservacaoEditado
    }
}

export default connect(mapStatetoProps, {
    cadastrarGrupoCardapio,
    removerGrupoCardapio,
    editarGrupoCardapio,
    buscarGrupoCardapio,
    cadastrarGrupoCardapioMantemCadastro,
    buscarGruposCardapioObservacaoPorGrupo,
    cadastrarGrupoCardapioObservacao,
    removerGrupoCardapioObservacao,
    editarGrupoCardapioObservacao,
    buscarGruposCardapioItemPorGrupo,
    navegarBreadCrumb
})(withRouter(CadastrarCardapioDigitalGrupo))
